import React, { useEffect, useState } from 'react';
import moment from 'moment';
import { compose } from 'recompose';
import styled from 'styled-components';
import { hot } from 'react-hot-loader';
import TimeField from 'react-simple-timefield';
import { Table, Form, Segment, Label, Input, Icon, Checkbox } from 'semantic-ui-react';

import RemarkModal from '../remark-modal';
import KpiModal from '../kpi-modal';
import FailedKpiModal from '../failedKPI/failedKPI.component';

import { NEGATIVE_SCORE } from 'op/components/evaluation';
import { withLocale } from 'op/components/locale';
import { withReportEvaluation } from './report-evaluation.helper';


const EvalContainer = styled.div`
	display:flex;
`;

const EvalButtonsContainer = styled.div`
	display:flex;
	border-radius: 5px;
	overflow: hidden;
	margin: 0 10px;
`;

const EvalButton = styled.button`
	height: 3em;
	border: none;
	flex: ${props => props.fluid ? 1 : 0};
	border-radius: ${props => props.rounded ? '5px' : 'none'};

	color: ${props => props.selected ? props.theme.white : props.theme.text};
	background-color: ${props => props.selected ? props.theme.dark : props.theme.white}; 

	outline: none !important;
	margin 0 1.5px;
`;

const QuantityInput = styled(Input)`
	min-width: 5em;

	input {
	text-align: center !important;
	}
`;

const Thing = styled.div`
	display: flex;
	justify-content: space-between;
`;

function diff(value1, value2) {
    var m1 = moment(value1, "HH:mm:ss");
    var m2 = moment(value2, "HH:mm:ss");
    var duration = moment.duration(m1.diff(m2));
    var result = moment.utc(duration._milliseconds).format("HH:mm:ss");
    return result;
}
function GetEnd(start, duration) {
    var m1 = moment(start, "HH:mm:ss");
    var durationArray = duration.split(":");
    var end = m1.add(Number(durationArray[0]), 'h');
    end = end.add(Number(durationArray[1]), 'm');
    end = end.add(Number(durationArray[2]), 's');
    var result = moment(end).format("HH:mm:ss");
    return result;
}
const ReportEvaluation = ({
    locale, ready, readOnly, report, evaluations, getExecutionLevelOptions, kpiTypes, reportType, invokeChange, onKpiAdd, sorting
}) => {
    const [clicked, setClicked] = useState(false);
    const [end, setEnd] = useState();

    useEffect(() => {
        setEnd(GetEnd(report.startTime || "00:00:00", report.duration || "00:00:00"));
    }, []);
    return (<Segment>
        {
            kpiTypes &&
            kpiTypes.length > 0 &&
            <Table celled sortable>
                <Table.Header>
                    <Table.Row>
                        <Table.HeaderCell
                            textAlign={locale._meta.rtl ? 'right' : 'left'}
                            sorted={sorting.column === 'kpi' ? sorting.direction : null}
                            onClick={() => sorting.sortBy('kpi')}
                        >
                            {locale.kpi}
                        </Table.HeaderCell>
                        <Table.HeaderCell
                            textAlign={locale._meta.rtl ? 'right' : 'left'}
                            sorted={sorting.column === 'value' ? sorting.direction : null}
                            onClick={() => sorting.sortBy('value')}
                        >
                            {locale.execution_level}
                        </Table.HeaderCell>
                        {
                            report && report.evaluations && report.evaluations.length > 0 && readOnly &&
                            (<Table.HeaderCell>
                                {locale.follow_up_kpi}
                            </Table.HeaderCell>)
                        }
                        {report && report.isKPI && !readOnly && (
                            <Table.HeaderCell>
                                {locale.follow_up_kpi}
                            </Table.HeaderCell>
                        )}
                    </Table.Row>
                </Table.Header>
                <Table.Body>
                    {kpiTypes
                        .filter(x => !x.isexpired || (evaluations[x.id] && evaluations[x.id].value != null))
                        .sort(sorting.sorter).map((kpi) => (
                            <Table.Row key={kpi.id}
                                //className={kpi.isexpired?'expired':'notExpired'}
                                negative={evaluations[kpi.id] && evaluations[kpi.id].value && evaluations[kpi.id].value <= NEGATIVE_SCORE}>
                                <Table.Cell>
                                    <Thing>
                                        <div>
                                            {kpi.name.split('\n').map((l, k) => (<span key={k}>{l}<br /></span>))}
                                        </div>
                                        {
                                            (readOnly ? evaluations[kpi.id] && evaluations[kpi.id].remarks : true) &&
                                            <RemarkModal
                                                report={report}
                                                readOnly={readOnly}
                                                value={evaluations[kpi.id] && evaluations[kpi.id].remarks}
                                                onChange={remarks => onKpiAdd(Object.assign({}, evaluations[kpi.id], {
                                                    kpi,
                                                    remarks
                                                }))} />
                                        }
                                    </Thing>
                                    <Thing>
                                        {
                                            <KpiModal
                                                report={report}
                                                readOnly={readOnly}
                                                value={kpi.name}
                                                kpiremark={kpi.kpiremark}
                                            />
                                        }
                                    </Thing>
                                    <Thing>
                                        {
                                            (readOnly ? evaluations[kpi.id] && evaluations[kpi.id].remarks : true) &&
                                            <FailedKpiModal
                                                report={kpi}
                                                readOnly={readOnly}
                                                remarks={evaluations[kpi.id] && evaluations[kpi.id].remarks}
                                                value={evaluations[kpi.id] && evaluations[kpi.id].value}
                                                onChange={remarks => onKpiAdd(Object.assign({}, evaluations[kpi.id], {
                                                    kpi,
                                                    remarks
                                                }))}
                                                clicked={clicked}
                                            />
                                        }
                                    </Thing>
                                </Table.Cell>
                                <Table.Cell
                                    textAlign='right'
                                    collapsing>
                                    <EvalContainer>
                                        <EvalButtonsContainer>
                                            {
                                                reportType &&
                                                reportType.type === 'execution_level' &&
                                                getExecutionLevelOptions(kpi).map(option => (
                                                    <EvalButton key={option.key}
                                                        selected={evaluations[kpi.id] && evaluations[kpi.id].value === option.value}
                                                        disabled={readOnly}
                                                        onClick={() => {
                                                            onKpiAdd(Object.assign({ type: reportType.type }, evaluations[kpi.id], {
                                                                kpi,
                                                                value: option.value
                                                            }));
                                                            setClicked(true);
                                                        }
                                                        }
                                                    >{option.key}</EvalButton>
                                                ))
                                            }
                                            {
                                                reportType &&
                                                ['score', 'quantity'].includes(reportType.type) &&
                                                <Form.Field style={{ width: '100%' }}>
                                                    <QuantityInput
                                                        fluid
                                                        value={evaluations[kpi.id] && evaluations[kpi.id].value || ''}
                                                        readOnly={readOnly}
                                                        onChange={(_, { value }) => onKpiAdd(Object.assign({ type: reportType.type }, evaluations[kpi.id], {
                                                            kpi,
                                                            value: parseInt(value)
                                                        }))}
                                                    />
                                                </Form.Field>
                                            }
                                            {

                                            }
                                        </EvalButtonsContainer>
                                        {
                                            reportType &&
                                            ['score', 'execution_level'].includes(reportType.type) &&
                                            <EvalButton
                                                rounded
                                                selected={!evaluations[kpi.id] || (evaluations[kpi.id] && (!evaluations[kpi.id].value || evaluations[kpi.id].value === 20))}
                                                disabled={readOnly}
                                                onClick={() => onKpiAdd(Object.assign({ type: reportType.type }, evaluations[kpi.id], {
                                                    kpi,
                                                    value: null
                                                }))}
                                            >{locale.none}</EvalButton>
                                        }
                                    </EvalContainer>
                                </Table.Cell>
                                {
                                    report && report.evaluations && report.evaluations.length > 0 && readOnly &&
                                    (<Table.Cell>
                                        {(evaluations[kpi.id] && evaluations[kpi.id].alert) ? 'Yes' : 'No'}
                                    </Table.Cell>)
                                }
                                {report && report.isKPI && !readOnly && (
                                    <Table.Cell>
                                        <Checkbox 
                                            checked={evaluations[kpi.id] && evaluations[kpi.id].alert}
                                            onChange={(e, { checked }) => onKpiAdd(Object.assign({}, evaluations[kpi.id], {
                                                kpi,
                                                alert: checked
                                            }))}
                                        />
                                    </Table.Cell>
                                )}
                            </Table.Row>
                        ))
                    }
                </Table.Body>
            </Table>
        }
        <Form.Group widths='equal'>
            {
                reportType &&
                reportType.type !== 'null' &&
                <Form.Field required={reportType.type !== 'quantity'}>
                    <label>{
                        reportType.type === 'quantity'
                            ? locale.quantity
                            : locale.execution_level_score
                    }</label>
                    {
                        reportType.type === 'execution_level' &&
                        <EvalButtonsContainer>
                            {
                                getExecutionLevelOptions(reportType).map(option => (
                                    <EvalButton key={option.key}
                                        fluid
                                        rounded
                                        selected={report[reportType.type] === option.value}
                                        onClick={() => !readOnly && invokeChange({ [reportType.type]: { $set: option.value } })}
                                    >{option.key}</EvalButton>
                                ))
                            }
                        </EvalButtonsContainer>
                    }
                    {
                        ['score', 'quantity'].includes(reportType.type) &&
                        <Form.Input
                            fluid
                            value={report[reportType.type] || ''}
                            readOnly={readOnly}
                            onChange={(_, { value }) => invokeChange({ [reportType.type]: { $set: parseInt(value) } })}
                        />
                    }
                </Form.Field>
            }
            <Form.Field>
                <label>{locale.duration}</label>
                <TimeField
                    value={report.duration || '00:00:00'}
                    onChange={(event) => {
                        invokeChange({ duration: { $set: event.target.value } })
                        setEnd(GetEnd(report.startTime, event.target.value))
                    }
                    }
                    input={<Form.Input />}
                    colon=":"
                    showSeconds
                    readOnly={readOnly}
                />
            </Form.Field>
        </Form.Group>
        <Form.Group widths='equal'>
            <Form.Field>
                <label>{locale.start_time}</label>
                <TimeField
                    value={report.startTime || '00:00:00'}
                    onChange={(event) => invokeChange({ startTime: { $set: event.target.value }, duration: { $set: diff(end, event.target.value) } })}
                    input={<Form.Input />}
                    colon=":"
                    showSeconds
                    readOnly={readOnly}
                />
            </Form.Field>
            <Form.Field>
                <label>{locale.end_time}</label>
                <TimeField
                    value={end || '00:00:00'}
                    onChange={(value) => {
                        setEnd(value.target.value);
                        invokeChange({
                            duration: {
                                $set: diff(value.target.value, report.startTime)
                                //moment.utc(moment(value.target.value,"HH:mm:ss").subtract(moment(report.startTime,"HH:mm:ss"))).format("hh:mm:ss")
                            }
                        }
                        );
                    }}
                    input={<Form.Input />}
                    readOnly={readOnly}
                    colon=":"
                    showSeconds
                />
            </Form.Field>
        </Form.Group>
    </Segment>);
}


export default compose(
    withLocale('report.evaluation'),
    withReportEvaluation,
    hot(module),
)(ReportEvaluation);
